import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=0636f595&scoped=true&"
import script from "./DocumentTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=0636f595&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636f595",
  null
  
)

export default component.exports